import React, { useEffect } from "react";

import Config from "../../config";
import AgenciesTable from "./AgenciesTable";
import Spinner from "../../components/Spinner";
import Error from "../../components/Error";
import Wrapper from "../../components/Wrapper";
import CustomButton from "../../components/CustomButton";
import Pagination from "../../components/Pagination";

import { ScrollView, Flex } from "@aws-amplify/ui-react";
import { useContx } from "../../AuthProvider";

const AgenciesTablePage = () => {
  const { isAdmin, agencies, getAgencies, loading, error, pagination, totals } =
    useContx();

  useEffect(() => {
    isAdmin && getAgencies(1);
    //eslint-disable-next-line
  }, []);

  let a = agencies;

  a = agencies.slice(
    (pagination?.agencies?.currentPage - 1) * pagination?.perPage,
    pagination?.agencies?.currentPage * pagination?.perPage
  );

  let content = (
    <>
      <Flex alignItems="center" padding={10}>
        <CustomButton
          path={Config.routes.addAgency}
          state="Agency"
          check={isAdmin}
        />
      </Flex>
      <Wrapper>
        <br></br>
        <ScrollView width="100%">
          <AgenciesTable agencies={a} isAdmin={isAdmin} />
          <Pagination
            fn={getAgencies}
            cp={pagination?.agencies?.currentPage}
            pp={pagination?.perPage}
            t={totals?.agencies?.total}
            v={totals?.agencies?.visited}
          />
        </ScrollView>
      </Wrapper>
    </>
  );

  if (loading) {
    content = <Spinner />;
  }

  if (error) {
    return <Error message={error} />;
  }

  return content;
};

export default AgenciesTablePage;
